import { ColumnId } from '../model/column-id.model';
import { TranslationKeyMap } from '../search.i18n';

export const tableColumns: Array<{
    id: ColumnId;
    label: string;
    classSuffix: string;
}> = [
    {
        id: ColumnId.USER_NAME,
        label: TranslationKeyMap._72_USERNAME,
        classSuffix: 'user-name',
    },
    {
        id: ColumnId.EVENT_DATE,
        label: TranslationKeyMap._9999_EVENT_DATE,
        classSuffix: 'event-date',
    },
    {
        id: ColumnId.EVALUATION_DATE,
        label: TranslationKeyMap._10001_EVALUATION_DATE,
        classSuffix: 'evaluation-date',
    },
    {
        id: ColumnId.SCORE,
        label: TranslationKeyMap._752_SCORE,
        classSuffix: 'score',
    },
    {
        id: ColumnId.EVALUATION_NAME,
        label: TranslationKeyMap._9998_EVALUATION_NAME,
        classSuffix: 'evaluation-name',
    },
    {
        id: ColumnId.STATUS,
        label: TranslationKeyMap._127_STATUS,
        classSuffix: 'status',
    },
    {
        id: ColumnId.SELECT,
        label: null,
        classSuffix: 'select',
    },
];
